var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"textfield",attrs:{"type":"number","id":_vm.id,"min":_vm.min,"max":_vm.max},domProps:{"value":_vm.displayValue},on:{"input":_vm.set,"wheel":function($event){$event.stopPropagation();},"keydown":_vm.filterKeys,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }